import { Component, Inject } from "@angular/core";
import { MAT_SNACK_BAR_DATA, MatSnackBar } from "@angular/material/snack-bar";

@Component({
    standalone: false,
    selector: "app-custom-snackbar",
    template: `
        <span class="mat-simple-snackbar-content">
            <ul class="ms-3">
                @for (message of data; track message) {
                <li>{{ message }}</li>
                }
            </ul>
        </span>
    `,
    styles: ["ul { margin: 0; padding: 0; list-style-type: disc; }"]
})
export class CustomSnackbarComponent {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: string[],
        public snackBar: MatSnackBar
    ) {}
}
